(() => {
  let r = (e) => {
    let r;
    var t,
      i,
      e = (r = document.currentScript
        ? document.currentScript.parentElement
        : e).querySelector(".main-blog__slider");
    e &&
      ((t = r.querySelector(".main-blog__navigation .swiper-button-next")),
      (i = r.querySelector(".main-blog__navigation .swiper-button-prev")),
      new Swiper(e, {
        slidesPerView: 1,
        spaceBetween: 8,
        speed: 800,
        navigation: { nextEl: t, prevEl: i },
        mousewheel: { forceToAxis: !0 },
        breakpoints: {
          576: { slidesPerView: 2, slidesPerGroup: 2, spaceBetween: 16 },
          990: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 24 },
          1360: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 24 },
        },
      }));
  };
  r(),
    document.addEventListener("shopify:section:load", function (e) {
      r(e.target);
    });
})();
